var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Drill--Streamline-Lucide",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8289",
    "data-name": "Trazado 8289",
    d: "M14.041,8.711a1.007,1.007,0,0,1-1.066,1.066H3.382A2.132,2.132,0,0,1,1.25,7.646V3.382A2.132,2.132,0,0,1,3.382,1.25h9.593a1.007,1.007,0,0,1,1.066,1.066Z",
    transform: "translate(-1.25 -1.25)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8290",
    "data-name": "Trazado 8290",
    d: "M11.25,3.75h4.264",
    transform: "translate(5.805 0.514)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8291",
    "data-name": "Trazado 8291",
    d: "M8.75,2.5h3.2a1.066,1.066,0,0,1,1.066,1.066V5.7a1.066,1.066,0,0,1-1.066,1.066H8.75",
    transform: "translate(4.041 -0.368)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8292",
    "data-name": "Trazado 8292",
    d: "M4.007,6.25,1.875,14.777",
    transform: "translate(-0.809 2.277)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8293",
    "data-name": "Trazado 8293",
    d: "M9.264,6.25v3.2A1.007,1.007,0,0,1,8.2,10.514H5",
    transform: "translate(1.396 2.277)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8294",
    "data-name": "Trazado 8294",
    d: "M4.375,14.777,6.507,6.25",
    transform: "translate(0.955 2.277)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8295",
    "data-name": "Trazado 8295",
    d: "M4.448,15.514a3.141,3.141,0,0,1-3.2-3.2A1.007,1.007,0,0,1,2.316,11.25H9.777a1.007,1.007,0,0,1,1.066,1.066v2.132a1.007,1.007,0,0,1-1.066,1.066Z",
    transform: "translate(-1.25 5.805)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrill);
export default __webpack_public_path__ + "static/media/drill.a1b7cc958dfe855be8e87442ede1d8cb.svg";
export { ForwardRef as ReactComponent };